
import { FormEventHandler, useState } from "react";
import { useNavigate } from "react-router-dom";
import useApi from "../../hooks/api/useApi";
import { Lock, Mail, UserIcon } from "lucide-react";


const Register = () => {
    const [errorMessage, setErrorMessage] = useState('');
    const [registered, setRegistered] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { request } = useApi();

    const navigate = useNavigate();

    const handleSubmit: FormEventHandler<HTMLFormElement> = async (event) => {
        event.preventDefault();

        const params = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                username,
                password,
                firstName,
                lastName
            }),
        };

        await request(`/users`, params, (data => {
            setRegistered(true)
        }), (error: Error) => {
            setErrorMessage(error.message)
        })
    };
    if (registered) {

        navigate("/login");
    }

    return (
        <section
            style={{
                background: `linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 50%, #f5f0ff 100%)`,
                padding: "80px 24px 90px",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* subtle grid pattern */}
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `
                        linear-gradient(rgba(59,130,246,0.04) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(59,130,246,0.04) 1px, transparent 1px)
                    `,
                    backgroundSize: "48px 48px",
                    pointerEvents: "none",
                }}
            />
            <div className="min-h-screen flex flex-col items-center justify-center p-6 relative overflow-hidden">
                {/* Background decoration */}
                {/* <div className="absolute top-[-20%] right-[-20%] w-[500px] h-[500px] rounded-full bg-white/20 blur-3xl" />
                <div className="absolute bottom-[-20%] left-[-20%] w-[500px] h-[500px] rounded-full bg-pink-900/20 blur-3xl" /> */}

                <div className="w-full max-w-sm bg-white/90 backdrop-blur-xl rounded-[2.5rem] p-8 shadow-2xl animate-in fade-in zoom-in-95 duration-500">
                    <div className="text-center mb-8">
                        <h1 className="text-2xl font-bold text-gray-800">ایجاد کاربر جدید</h1>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-1">
                            <label className="text-xs font-bold text-gray-600 ml-1 uppercase">نام</label>
                            <div className="relative">
                                <UserIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <input
                                    type="text"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    placeholder="علی"
                                    className="w-full pl-12 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all font-medium"
                                    required
                                />
                            </div>
                        </div>

                        <div className="space-y-1">
                            <label className="text-xs font-bold text-gray-600 ml-1 uppercase">نام خانوادگی</label>
                            <div className="relative">
                                <UserIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <input
                                    type="text"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    placeholder="محمدی"
                                    className="w-full pl-12 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all font-medium"
                                    required
                                />
                            </div>
                        </div>

                        <div className="space-y-1">
                            <label className="text-xs font-bold text-gray-600 ml-1 uppercase">نام کاربری</label>
                            <div className="relative">
                                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <input
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="نام کاربری"
                                    className="w-full pl-12 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all font-medium"
                                    required
                                />
                            </div>
                        </div>

                        <div className="space-y-1">
                            <label className="text-xs font-bold text-gray-600 ml-1 uppercase">رمزعبور</label>
                            <div className="relative">
                                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="رمز عبور"
                                    className="w-full pl-12 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all font-medium"
                                    required
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full py-4 mt-2 rounded-2xl bg-gray-900 text-white font-bold text-lg shadow-lg hover:bg-black active:scale-[0.98] transition-all flex items-center justify-center gap-2"
                        >
                            {isLoading ? <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" /> : "Sign Up"}
                        </button>
                    </form>

                    <div className="mt-8 text-center">
                        <p className="text-gray-500 text-sm">
                            حساب کاربری دارید؟{' '}
                            <a href='/login' className="font-bold text-blue-600 hover:text-blue-700">
                                ورود
                            </a>
                        </p>
                    </div>
                </div>
            </div></section>
    );
};

export default Register;